document.addEventListener('DOMContentLoaded', function () {
    const video = document.getElementById('heroVideoSoluciones');
    const button = document.getElementById('soundToggle');

    if (video && button) {
        button.addEventListener('click', function () {
            if (video.muted) {
                // Activar audio
                video.muted = false;
                video.volume = 1;
                button.textContent = "🔇";
            } else {
                // Desactivar audio
                video.muted = true;
                video.volume = 0;
                button.textContent = "🔊";
            }
        });
    }
});
